import * as moment from 'moment';

export const convertYearDayToDate = (year, day) => {
  const date = new Date(year, 0);
  date.setDate(day);
  date.setHours(0);
  date.setMinutes(0);
  return date;
};

export const getVisitBookedForDate = visit => {
  let bookedFor = '-';
  let bookedForDate;
  if (visit.booked_slot) {
    bookedForDate = convertYearDayToDate(visit.booked_slot.year, visit.booked_slot.day);
    bookedFor = `${moment(bookedForDate).format('DD/MM/YYYY')} ${visit.booked_slot.day_of_week} ${visit.booked_slot.slot_begin} - ${visit.booked_slot.slot_end}`;
  }
  return {
    bookedFor,
    bookedForDate,
  };
};
